import React from 'react'

const Transition = () =>
  <div className='usa-grid'>
    <br />
    <h4>Hi Veteran’s Information Portal / Loan Guaranty User!</h4>
    <p>
      You were attempting to go to the VIP Portal to access VA Loan Guaranty websites.  
      The VIP Portal has been decommissioned and is no longer available.  
      There is a new entry point for VA Loan Guaranty applications called LGY Hub.  
      It uses 2 Factor Authentication (currently through ID.me) to verify or authenticate users for VA systems.  
      You will set up an ID.me account (if you don’t already have one) for the logon portion of the new LGY Hub.  
    </p>
    <p>
      Click here to go to LGY Hub – <a href="https://lgy.va.gov">https://lgy.va.gov</a>
    </p>
    <p>
    There are various aides to guide you through the registration process.  There is:
      <ul>
        <li>A video - see the link to it on Announcements and also a small icon beside “the “Sign In or Register” link in the header)</li>
        <li>Full User Registration guide - at the top of the LGY Hub Help screen.</li>
        <li>FAQ Summary - there is also a FAQ on the Help screen, that has a summary of the registration steps</li>
      </ul>
    </p>
    <p>
      Please note help requests should not be submitted to the VIP mailbox but by using the Submit ticket button at the bottom of the LGY Hub Help page.
    </p>
    <p>
      We look forward to continuing to do business with you and thank you for your participation!
    </p>
    <br />
    <br />
    <br />
  </div>

export default Transition
